import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ErrorWrapper from '@/app/ErrorWrapper';
import { routesPath } from '../../utils/routesPath';
import { authApi } from '../../api';
import { Button, notification } from 'antd';
import DatePicker from 'react-datepicker';
import { dateStringToYYYYMMDD } from '../../utils/functions';
import 'react-datepicker/dist/react-datepicker.css';
import { ValidationCriteria } from '@/components';
import { useTranslation } from 'react-i18next'; // Thêm import

const SignUpComponent = ({ ...props }) => {
    const { t } = useTranslation(); // Thêm hook
    const navigate = useNavigate();
    const [validation, setValidation] = useState({
        length: false,
        lowercase: false,
        uppercase: false,
        number: false,
        specialChar: false
    });
    const [registerData, setRegisterData] = useState({
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        dateOfBirth: '',
        gender: 'Male',
        phone: ''
    });
    const [loadingRegister, setLoadingRegister] = useState(false);
    const [comparePassword, setComparepassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [agreements, setAgreements] = useState({
        terms: false,
        policy: false
    });

    const handleSetRegisterData = (e) => setRegisterData({ ...registerData, ...e });

    const handleRegister = async () => {
        // (Registration logic remains the same)
        if (
            !registerData.email ||
            !registerData.firstName ||
            !registerData.lastName ||
            !registerData.password ||
            !registerData.dateOfBirth ||
            !registerData.gender ||
            !registerData.phone
        ) {
            notification.info({ message: t('Signup_NotifyMissingField'), duration: 2 });
            return;
        }
        if (registerData.password !== comparePassword) {
            notification.info({ message: t('Signup_NotifyPasswordMismatch'), duration: 2 });
            return;
        }

        if (!agreements.terms || !agreements.policy) {
            notification.info({
                message: t('Signup_NotifyAgreeTerms'),
                duration: 2
            });
            return;
        }

        try {
            setLoadingRegister(true);
            await authApi
                .register({
                    ...registerData,
                    dateOfBirth: dateStringToYYYYMMDD(registerData.dateOfBirth)
                })
                .then((res) => {
                    notification.success({ message: t('Signup_NotifyRegisterSuccess') });
                    navigate(`../${routesPath.COMMON.HOME}`);
                })
                .catch((err) => {
                    const errText = err?.response?.data?.message || '';
                    if (errText.includes('already exists')) {
                        notification.info({ message: t('Signup_NotifyExistUser') });
                    } else {
                        notification.info({ message: t('Signup_NotifyRegisterError') });
                    }

                    console.error(err);
                })
                .finally(() => {
                    setLoadingRegister(false);
                });
        } catch (error) {
            console.error(error);
        }
    };

    const handlePasswordChange = (e) => {
        // (Password change logic remains the same)
        const { value } = e.target;

        setRegisterData((prevData) => ({
            ...prevData,
            password: value
        }));

        const hasLength = value.length >= 8;
        const hasLowercase = /[a-z]/.test(value);
        const hasUppercase = /[A-Z]/.test(value);
        const hasNumber = /[0-9]/.test(value);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

        setValidation({
            length: hasLength,
            lowercase: hasLowercase,
            uppercase: hasUppercase,
            number: hasNumber,
            specialChar: hasSpecialChar
        });
    };

    const isPasswordValid = Object.values(validation).every(Boolean);
    const areAgreementsChecked = agreements.terms && agreements.policy;

    const isFormValid =
        registerData.email &&
        registerData.firstName &&
        registerData.lastName &&
        registerData.password &&
        registerData.dateOfBirth &&
        registerData.gender &&
        registerData.phone &&
        comparePassword &&
        registerData.password === comparePassword &&
        isPasswordValid &&
        areAgreementsChecked;

    // --- This style remains the same ---
    const iconStyle = {
        position: 'absolute',
        top: '50%',
        right: '12px',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        color: '#555'
    };

    return (
        <div className="auth option2">
            <div className="auth_left !w-[500px]">
                <div className="card">
                    <div className="card-body">
                        {/* (Logo, Title, Name, Email fields remain the same) */}
                        <div className="text-center flex items-center flex-col">
                            <Link
                                to="/"
                                className="flex justify-center items-center max-h-[140px] overflow-hidden">
                                <img
                                    className="rounded-lg w-1/2"
                                    src="/assets/images/logo.png"
                                    alt="logo"
                                />
                            </Link>
                            <div
                                className="card-title"
                                style={{ marginTop: '16px' }}>
                                {t('Signup_CreateNewAccount')}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-label">
                                        {t('Signup_FirstName')}
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t('Signup_EnterFirstName')}
                                        value={registerData.firstName}
                                        onChange={(e) =>
                                            handleSetRegisterData({ firstName: e.target.value })
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-label">
                                        {t('Signup_LastName')}
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t('Signup_EnterLastName')}
                                        value={registerData.lastName}
                                        onChange={(e) =>
                                            handleSetRegisterData({ lastName: e.target.value })
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                {t('Signup_EmailAddress')}
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                placeholder={t('Signup_EnterEmail')}
                                value={registerData.email}
                                onChange={(e) => handleSetRegisterData({ email: e.target.value })}
                            />
                        </div>

                        {/* --- Password / Confirm Password Row --- */}
                        <div className="row">
                            {/* --- Password --- */}
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-label">
                                        {t('Signup_Password')}
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    {/* --- 2. UPDATED JSX with <i> tag and dynamic className --- */}
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className="form-control"
                                            placeholder={t('Signup_PasswordPlaceholder')}
                                            value={registerData.password}
                                            onChange={handlePasswordChange}
                                        />
                                        <i
                                            className={
                                                showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                                            }
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={iconStyle}
                                            aria-hidden="true" // Good for accessibility
                                        ></i>
                                    </div>
                                    {/* -------------------------------------------------------- */}
                                </div>
                            </div>

                            {/* --- Confirm Password --- */}
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-label">
                                        {t('Signup_ConfirmPassword')}
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    {/* --- 3. UPDATED JSX for Confirm Password --- */}
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            className="form-control"
                                            placeholder={t('Signup_PasswordPlaceholder')}
                                            value={comparePassword}
                                            onChange={(e) => setComparepassword(e.target.value)}
                                        />
                                        <i
                                            className={
                                                showConfirmPassword
                                                    ? 'fa fa-eye-slash'
                                                    : 'fa fa-eye'
                                            }
                                            onClick={() =>
                                                setShowConfirmPassword(!showConfirmPassword)
                                            }
                                            style={iconStyle}
                                            aria-hidden="true"></i>
                                    </div>
                                    {/* ------------------------------------------- */}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {/* (Password validation criteria list remains the same) */}
                            {registerData.password.length > 0 && (
                                <ul /* style={styles.criteriaList} */>
                                    <ValidationCriteria
                                        isValid={validation.length}
                                        text={t('Signup_ValidationLength')}
                                    />
                                    <ValidationCriteria
                                        isValid={validation.lowercase}
                                        text={t('Signup_ValidationLowercase')}
                                    />
                                    <ValidationCriteria
                                        isValid={validation.uppercase}
                                        text={t('Signup_ValidationUppercase')}
                                    />
                                    <ValidationCriteria
                                        isValid={validation.number}
                                        text={t('Signup_ValidationNumber')}
                                    />
                                    <ValidationCriteria
                                        isValid={validation.specialChar}
                                        text={t('Signup_ValidationSpecialChar')}
                                    />
                                </ul>
                            )}
                        </div>

                        {/* (DOB, Gender, Phone, Checkboxes, and Button remain the same) */}
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-label">
                                        {t('Signup_DateOfBirth')}
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <DatePicker
                                        selected={registerData.dateOfBirth}
                                        onChange={(e) => handleSetRegisterData({ dateOfBirth: e })}
                                        placeholderText={t('Signup_DateOfBirthPlaceholder')}
                                        className="form-control"
                                        wrapperClassName="d-block"
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-label">
                                        {t('Signup_Gender')}
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <select
                                        className="form-control input-height"
                                        onChange={(e) =>
                                            handleSetRegisterData({ gender: e.target.value })
                                        }
                                        name="gender"
                                        value={registerData.gender}>
                                        <option value="Male">{t('Signup_Male')}</option>
                                        <option value="Female">{t('Signup_Female')}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                {t('Signup_Phone')}
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                            <input
                                type="tel"
                                className="form-control"
                                placeholder={t('Signup_EnterPhone')}
                                value={registerData.phone}
                                onChange={(e) => handleSetRegisterData({ phone: e.target.value })}
                            />
                        </div>

                        <div
                            className="form-check"
                            style={{ marginBottom: '1rem' }}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="termsCheckbox"
                                checked={agreements.terms}
                                onChange={(e) =>
                                    setAgreements((prev) => ({ ...prev, terms: e.target.checked }))
                                }
                            />
                            <label
                                className="form-check-label"
                                htmlFor="termsCheckbox">
                                {t('Signup_AgreeMailingList')}
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                        </div>
                        <div
                            className="form-check"
                            style={{ marginBottom: '1rem' }}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="policyCheckbox"
                                checked={agreements.policy}
                                onChange={(e) =>
                                    setAgreements((prev) => ({ ...prev, policy: e.target.checked }))
                                }
                            />
                            <label
                                className="form-check-label"
                                htmlFor="policyCheckbox">
                                {t('Signup_AgreeContact')}
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                        </div>

                        <div
                            className="text-center"
                            style={{ marginTop: '1rem' }}>
                            <Button
                                onClick={() => handleRegister()}
                                className="btn btn-primary btn-block hover:shadow-md"
                                loading={loadingRegister}
                                disabled={!isFormValid || loadingRegister}>
                                {t('Signup_CreateNewAccount')}
                            </Button>
                            <div className="text-muted mt-4">
                                {t('Signup_AlreadyHaveAccount')}{' '}
                                <Link
                                    to="/login"
                                    className="underline font-bold">
                                    {t('Signup_SignIn')}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

SignUpComponent.displayName = 'SignUp';

const SignUp = (props) => {
    return (
        <ErrorWrapper>
            <SignUpComponent
                data-id="SignUp-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default SignUp;
